import { h, defineComponent, ref } from 'vue';
import animationData from '@/assets/animations/falling_confetti.json';

export const FallingConfetti = defineComponent({
  name: 'FallingConfetti',
  setup() {
    const animationFinished = ref(false);
    const complete = (source: { stop: () => void }) => {
      source.stop();
      animationFinished.value = true;
    };

    return function render() {
      return h('div', {
        class: 'lottie-animation',
      }, [
        h('lottie', {
          class: `lottie-animation__falling-confetti${animationFinished.value ? ' lottie-animation--finished' : ''}`,
          props: {
            animationData,
            loop: false,
            autoPlay: true,
          },
          on: {
            complete,
          },
        }),
      ]);
    };
  },
});
